// extracted by mini-css-extract-plugin
module.exports = {"links":"FooterColumn_links__nWDOA","title":"FooterColumn_title__wpQou","footerLink":"FooterColumn_footerLink__MiMe4"};